import React, {useEffect, useState} from 'react';
import {Anchor, Label, LoadingSection, Section} from "../../../../common/fusion-ui";
import {useTheme} from "../../../../common/ProjectThemeProvider";
import {useToast} from "../../../../common/fusion-ui/provider/ToastProvider";
import {
    checkNullArr,
    checkNullJson,
    formatDate,
    getJsonValue,
    getJsonValueFromNestedKeys,
    isBoolTrue,
    isJsonValueTrue,
    limitStringWords
} from "../../../../common/fusion-ui/utils/ReactUtils";
import {printError, printLog, sendRequest} from "../../../utils/AppUtils";
import {Constants, CssVariant, DefStrNA, Messages} from "../../../../common/fusion-ui/config/FusionConfig";
import {Keys, ModuleRouteUrls, Modules, ReqUrls} from "../../../config/AppConfig";
import useScreenSize from "../../../../common/fusion-ui/hook/useScreenSize";
import {useReduxPersistSessionData} from "../../../hook/useReduxPersistSessionData";
import {useConfig} from "../../../context/ConfigProvider";
import {Link} from "react-router-dom";
import {Tooltip} from "@mui/material";
import {AutoPlaySlider, ThemedButton} from "../../../index";
import {AnimationType, FramerAnimator} from "../../../../common/fusion-ui/animation/FramerAnimator";

const DashRecentPanel = React.memo(({
                                        className = "", style = {}
                                    }) => {
    const TAG = "DashRecentPanel";

    const theme = useTheme();
    const {showToast, changeToastVariant} = useToast();
    const {isScreenUpSm, isScreenXs, isScreenSm} = useScreenSize();
    const {isConfigTrue, getConfig} = useConfig();

    const animator = new FramerAnimator();

    const PANEL_HEIGHT = isScreenUpSm ? ('auto') : '51vh';

    const Fields = {
        recentList_Session: 'recentList_Session',
        isDataLoading: 'isDataLoading',
        isDataFound: 'isDataFound',
        dataLoadingMsg: 'dataLoadingMsg',
        isDataFetched: 'isDataFetched',

        defIndex: 'defIndex',
    };
    const [fieldsData, setFieldsData] = useState({});

    const {sessionData, updateSessionStoreFieldValue} = useReduxPersistSessionData({
        keys: [Fields.recentList_Session],
    });

    useEffect(() => {
        fetchPanelData();
    }, [sessionData]);
    return (<>
        {animator.setAnimationType(AnimationType.SLIDE_LEFT).setDuration(700).render(<div className={`mt-3 ${className}`} style={{...style}}>
            <div className={'m-0 p-0 w-100 h-100'}>
                <Section className={'px-3 py-2 scroller scroller-y-auto scroll-dark'}
                         title={'Recent Masterclass'}
                         titleClassName={'fw-semi-bold'}
                         titleColor={theme.text}
                         titleAt={'start'}
                         borderless={true} shadowVariant={''}
                         style={{boxShadow: theme.boxShadowMdSm, height: PANEL_HEIGHT,}}>
                    <div>
                        <LoadingSection
                            labelClassName={'m-2 w-100 fs-normal'}
                            heightClass={75}
                            color={theme.text70}
                            success={isFieldTrue(Fields.isDataFound)}
                            loading={isFieldTrue(Fields.isDataLoading)}
                            msg={getField(Fields.dataLoadingMsg)}
                        />

                        {(!isFieldTrue(Fields.isDataLoading) && isFieldTrue(Fields.isDataFound)) && <div>
                            {/*records*/}
                            <AutoPlaySlider
                                height={'auto'}
                                items={[renderVideoRecord(), renderPubRecord(), renderDocRecord(), renderCsRecord(),]}
                            />
                            {/*<div>*/}
                            {/*    {renderVideoRecord()}*/}
                            {/*    {renderPubRecord()}*/}
                            {/*    {renderDocRecord()}*/}
                            {/*    {renderCsRecord()}*/}
                            {/*</div>*/}

                            {/*more-btn*/}
                            {<div className={'m-0 p-0 mt-3 mb-2 w-100'}>
                                <ThemedButton
                                    className={'w-100 px-2 py-2 rounded-3 fw-semi-bold'}
                                    text={`More`}
                                    height={'36px'}
                                    href={ModuleRouteUrls[Modules.Documents]}
                                    onClick={() => {
                                        window.location.href = ModuleRouteUrls[Modules.Documents];
                                    }}
                                />
                            </div>}
                        </div>}
                    </div>
                </Section>
            </div>
        </div>)}
    </>);


    function renderVideoRecord() {
        return checkNullArr(getModuleRecords(Modules.Videos)) && <div className={'mt-2'}>
            {getModuleRecords(Modules.Videos).map((item, index) => {
                return <Section
                    className={'p-0 h-100'}
                    overflow={'hidden'}
                    key={index + getJsonValue(item, 'title')}
                    borderColor={theme.text20}>
                    <div className={''} style={{color: theme.text}}>
                        <div className={''}>
                            <iframe
                                className="embed-responsive-item"
                                title={`Video ${index}`}
                                width="100%"
                                height="100px"
                                src={`https://www.youtube.com/embed/${getJsonValue(item, 'link')}`}
                                allowFullScreen/>
                        </div>
                        <div className={'px-3 mb-2'}>
                            {/*title*/}
                            <div>
                                <Anchor href={`https://www.youtube.com/embed/${getJsonValue(item, 'link')}`} target={'_blank'}>
                                    <Label className={'m-0 p-0 fw-semi-bold text-break'} textAt={'start'}
                                           tooltip={(getJsonValue(item, 'title') + '').length >= 40 ? getJsonValue(item, 'title') : ''}>
                                        {limitStringWords(getJsonValue(item, 'title'), 40, '', '...')}
                                    </Label>
                                </Anchor>
                            </div>

                            {/*insertDate*/}
                            <div className={'mt-n1'}>
                                <Label className={'m-0 p-0 fs-sm fw-semi-bold'} textAt={'start'} color={theme.text40}>
                                    {formatDate(getJsonValue(item, 'insertDate'), Constants.DD_MMM_YYYY_DASH)}
                                </Label>
                            </div>
                        </div>
                    </div>
                </Section>
            })}
        </div>
    }

    function renderPubRecord() {
        return renderGenericLinkList(getModuleRecords(Modules.Publication));
    }

    function renderDocRecord() {
        return renderGenericLinkList(getModuleRecords(Modules.Documents));
    }

    function renderCsRecord() {
        return renderGenericLinkList(getModuleRecords(Modules.CaseStudy));
    }

    function renderGenericLinkList(linkList) {
        return checkNullArr(linkList) && <div className={'mt-2x mt-n4'}>
            <div>
                {linkList.map((item, index) => {
                    return <div key={index + getJsonValue(item, 'title')}
                                className={'mb-1'} style={{color: theme.text}}>
                        <label className={'text-wrap d-flex flex-wrap w-auto'} style={{lineHeight: 1.2}}>
                            {/*title-link*/}
                            <span>
                                <Link
                                    className={'fw-semi-boldx m-0 p-0 footer-link text-wrap'}
                                    to={getJsonValue(item, 'link', DefStrNA)}
                                    target={"_blank"}>
                                    <Tooltip title={(getJsonValue(item, 'title') + '').length >= 25 ? getJsonValue(item, 'title') : ''}>
                                        <span className={'text-wrap'}>
                                            {limitStringWords(getJsonValue(item, 'title'), 25, '', '...')}&nbsp;&nbsp;
                                        </span>
                                    </Tooltip>
                                </Link>
                            </span>

                            {/*date*/}
                            <span className={'fs-sm text-nowrap fw-semi-boldx'} style={{color: theme.text50}}>
                                ({formatDate(getJsonValue(item, 'insertDate'), Constants.DD_MMM_YYYY_DASH)})&nbsp;
                            </span>

                            {/*module*/}
                            <span className={'text-nowrap'}>
                                <span className={'rounded-10 text-center-force fs-sm fw-semi-bold'}
                                      style={{backgroundColor: theme.text10, color: theme.text30}}>
                                    &nbsp;&nbsp;{getJsonValue(item, 'moduleName')}&nbsp;&nbsp;
                                </span>
                            </span>
                        </label>
                    </div>
                })}
            </div>
        </div>
    }

    async function fetchPanelData(checkBefore = true) {
        const fun = 'fetchPanelData:';
        if ((!checkBefore || (checkBefore && !isFieldTrue(Fields.isDataFetched))) && (isConfigTrue(Keys.config_showRecentPanel) && isConfigTrue(Keys.config_showHomeRightPanels))) {
            updateField(Fields.isDataFetched, true);
            updateField(Fields.isDataFound, false);
            updateField(Fields.isDataLoading, true);
            updateField(Fields.dataLoadingMsg, "");

            //send-request
            const REQUEST_OPTIONS = {};
            try {
                const sessionDataAvail = checkNullJson(getJsonValue(sessionData, Fields.recentList_Session));
                // log(fun, 'sessionData:', sessionData);
                // log(fun, 'sessionDataAvail:', sessionDataAvail);
                if (sessionDataAvail) {
                    updateField(Fields.isDataFound, true);
                    updateField(Fields.isDataLoading, false);
                } else {
                    sendRequest({
                        reqUrl: ReqUrls.dashRecentPanel__fetchData, reqOptions: REQUEST_OPTIONS, onFetched: ((fetchedData) => {
                            log(fun, 'fetchedData:', fetchedData);

                            const recentData = getJsonValueFromNestedKeys(fetchedData, ['data', 'recentData'], []);
                            const success = isJsonValueTrue(fetchedData, 'success');
                            const message = getJsonValue(fetchedData, 'message');

                            updateField(Fields.isDataFound, success);
                            if (success) {
                                // toast(message, CssVariant.success)
                                updateSessionStoreFieldValue(Fields.recentList_Session, recentData);
                                updateField(Fields.isDataLoading, false);
                            } else {
                                toast(message, CssVariant.danger)
                                updateField(Fields.dataLoadingMsg, message);
                                updateField(Fields.isDataLoading, false);
                            }
                        }), onError: ((error) => {
                            logErr(fun, error);
                            toast("Couldn't load recent-data, please refresh again!", CssVariant.danger)
                            updateField(Fields.dataLoadingMsg, Messages.fetchError);
                            updateField(Fields.isDataFound, false);
                            updateField(Fields.isDataLoading, false);
                        }),
                    });
                }
            } catch (error) {
                logErr(fun, error);
                toast("Couldn't load recent-data, please refresh again!", CssVariant.danger)
                updateField(Fields.dataLoadingMsg, Messages.fetchError);
                updateField(Fields.isDataFound, false);
                updateField(Fields.isDataLoading, false);
            }
        }
    }

    function getModuleRecords(moduleName) {
        if (checkNullJson(getJsonValue(sessionData, Fields.recentList_Session))) {
            return checkNullArr(getJsonValue(getJsonValue(sessionData, Fields.recentList_Session), moduleName)) ? getJsonValue(getJsonValue(sessionData, Fields.recentList_Session), moduleName) : [];
        }
        return [];
    }

    function updateField(field, value) {
        setFieldsData(prevState => ({...prevState, [field]: value}));
    }

    function getField(field, defValue) {
        return getJsonValue(fieldsData, field, defValue);
    }

    function isFieldTrue(field) {
        return isBoolTrue(getField(field), true, true);
    }

    function toast(text, variant) {
        showToast(text);
        changeToastVariant(variant);
        log(...[text]);
    }

    function log(...text) {
        printLog(TAG, ...text);
    }

    function logErr(...text) {
        printError(TAG, ...text);
    }
});
export default DashRecentPanel;
